(function () {
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var drop = document.getElementById('drop');

  // Ingredient tiles
  var ING = [
    ['01', 'Calendula + castor oil', 'Calendula flowers are steeped in castor oil. The infused oil is part of the balm’s base.'],
    ['02', 'Shea butter', 'Shea butter is blended into the formula. It contributes to the balm’s soft feel on lips.'],
    ['03', 'Candelilla wax', 'Candelilla is the plant wax in this formula. It gives the balm its structure.'],
    ['04', 'Cocoa butter', 'Cocoa butter joins shea butter and the infused oil in the balm.'],
    ['05', 'Vitamin E', 'Vitamin E is part of the formula. The vitamin E ingredient is carried in safflower and sunflower oils.']
  ];
  document.querySelectorAll('.tile').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.tile').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      t.setAttribute('aria-selected', 'true');
      var d = ING[+t.dataset.i];
      document.getElementById('tdNum').textContent = d[0];
      document.getElementById('tdName').textContent = d[1];
      document.getElementById('tdText').textContent = d[2];
    });
  });

  // Gallery
  var gEl = document.getElementById('galleryData');
  var G = gEl ? JSON.parse(gEl.textContent) : [];
  function show(i) {
    var g = G[i], im = document.getElementById('stageImg');
    if (!g || !im) return;
    im.src = g[0]; im.alt = g[1]; im.className = g[2];
    document.getElementById('stageCap').textContent = 'Batch No. 001 / ' + g[3];
    document.querySelectorAll('.thumbs button').forEach(function (b) { b.setAttribute('aria-selected', String(+b.dataset.g === i)); });
  }
  document.querySelectorAll('.thumbs button').forEach(function (b) { b.addEventListener('click', function () { show(+b.dataset.g); }); });
  document.querySelectorAll('[data-view]').forEach(function (a) { a.addEventListener('click', function () { show(+a.dataset.view); }); });

  // Stacked statements brighten as they scroll into view
  var items = [].slice.call(document.querySelectorAll('#stackList li'));
  function onScroll() {
    var vh = window.innerHeight;
    items.forEach(function (li) { li.classList.toggle('on', li.getBoundingClientRect().top < vh * 0.72); });
  }
  if (items.length) { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  // Buy: empty the cart, add this batch, go straight to checkout.
  var form = document.getElementById('buy-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('buyBtn'), toast = document.getElementById('toast');
      var id = form.querySelector('[name="id"]').value;
      var q = form.querySelector('[name="quantity"]:checked');
      var qty = q ? +q.value : 1;
      btn.disabled = true; toast.textContent = 'Reserving your tin…';
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: +id, quantity: qty }] })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart.');
          window.location.href = root + 'checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          toast.textContent = err.message + ' Please try again.';
          refreshStock();
        });
    });
  }

  // Live stock: re-render this section from Shopify every 20 seconds and swap in the counter.
  function refreshStock() {
    if (!drop) return;
    var id = drop.dataset.sectionId;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('drop');
        if (!fresh) return;
        if (fresh.dataset.available !== drop.dataset.available) { window.location.reload(); return; }
        var a = doc.querySelector('[data-stock]'), b = document.querySelector('[data-stock]');
        if (a && b) b.innerHTML = a.innerHTML;
        var la = doc.querySelector('[data-stock-line]'), lb = document.querySelector('[data-stock-line]');
        if (la && lb) lb.innerHTML = la.innerHTML;
      })
      .catch(function () {});
  }
  if (drop && drop.dataset.available === 'true') {
    setInterval(function () { if (!document.hidden) refreshStock(); }, 20000);
  }

  // Countdown to the launch time in the theme settings.
  var cds = [].slice.call(document.querySelectorAll('[data-countdown]'));
  var launchAt = cds.length ? Date.parse(cds[0].dataset.countdown) : NaN;
  if (!isNaN(launchAt)) {
    var label = new Date(launchAt).toLocaleString(undefined, { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    document.querySelectorAll('[data-launch-label]').forEach(function (el) { el.textContent = label; });
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var ms = Math.max(0, launchAt - Date.now()), t = Math.floor(ms / 1000);
      var u = { d: Math.floor(t / 86400), h: Math.floor(t % 86400 / 3600), m: Math.floor(t % 3600 / 60), s: t % 60 };
      cds.forEach(function (cd) {
        Object.keys(u).forEach(function (k) { var b = cd.querySelector('[data-u="' + k + '"]'); if (b) b.textContent = pad(u[k]); });
        if (!ms) { cd.hidden = true; var done = cd.parentNode.querySelector('[data-countdown-done]'); if (done) done.hidden = false; }
      });
      if (ms) setTimeout(tick, 1000 - Date.now() % 1000);
    };
    tick();
  }

  // Pre-launch sign-up straight to the Klaviyo list (client API, public site ID only).
  document.querySelectorAll('[data-klaviyo-form]').forEach(function (f) {
    var msg = f.parentNode.querySelector('[data-form-msg]');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = f.querySelector('input[type="email"]'), btn = f.querySelector('button');
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Please enter a valid email.'; input.focus(); return; }
      btn.disabled = true; msg.textContent = 'Adding you to the list…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(f.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Batch 001 landing page',
          profile: { data: { type: 'profile', attributes: { email: email, properties: { signup_source: 'Batch 001 landing page' } } } }
        }, relationships: { list: { data: { type: 'list', id: f.dataset.list } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        f.hidden = true;
        msg.textContent = 'You’re on the list. We’ll email you before the drop opens.';
        try { window.localStorage.setItem('balm_signed_up', '1'); } catch (err) {}
      }).catch(function () {
        btn.disabled = false;
        msg.textContent = 'Something went wrong. Please try again.';
      });
    });
  });
})();

(function () {
  var dlg = document.querySelector('[data-ing-dialog]');
  var dataEl = document.querySelector('[data-ing-data]');
  if (dlg && dataEl && typeof dlg.showModal === 'function') {
    var items = JSON.parse(dataEl.textContent);
    var idx = 0, opener = null;
    var render = function (i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      var img = dlg.querySelector('[data-ing-img]');
      img.src = it.img; img.alt = it.name;
      dlg.querySelector('[data-ing-kicker]').textContent = it.kicker;
      dlg.querySelector('[data-ing-name]').textContent = it.name;
      dlg.querySelector('[data-ing-lead]').textContent = it.lead;
      var ul = dlg.querySelector('[data-ing-pts]');
      ul.innerHTML = '';
      it.points.forEach(function (p) { var li = document.createElement('li'); li.textContent = p; ul.appendChild(li); });
      dlg.querySelector('[data-ing-count]').textContent = (idx + 1) + ' / ' + items.length;
    };
    items.forEach(function (it) { var p = new Image(); p.src = it.img; });
    document.querySelectorAll('[data-ing]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = items.findIndex(function (it) { return it.key === b.dataset.ing; });
        opener = b; render(i < 0 ? 0 : i); dlg.showModal();
      });
    });
    dlg.querySelectorAll('[data-ing-step]').forEach(function (b) {
      b.addEventListener('click', function () { render(idx + (+b.dataset.ingStep)); });
    });
    dlg.querySelectorAll('[data-ing-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') render(idx + 1);
      if (e.key === 'ArrowLeft') render(idx - 1);
    });
    dlg.addEventListener('close', function () { if (opener && !document.activeElement.matches('input')) opener.focus({ preventScroll: true }); });
  }

  document.querySelectorAll('[data-focus-signup]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById('signup');
      var input = target && target.querySelector('input[type="email"]');
      if (!input) return;
      e.preventDefault();
      var open = document.querySelector('[data-ing-dialog][open]');
      if (open) open.close();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
    });
  });

  var bar = document.querySelector('[data-mbar]');
  if (bar && 'IntersectionObserver' in window) {
    bar.hidden = false;
    var watched = [].slice.call(document.querySelectorAll('.hero, [data-prelaunch], #shop .pdp-info, footer'));
    var visible = new Set();
    var update = function () {
      var typing = document.activeElement && document.activeElement.tagName === 'INPUT';
      bar.classList.toggle('on', visible.size === 0 && !typing);
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      update();
    }, { threshold: 0.15 });
    watched.forEach(function (el) { io.observe(el); });
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', function () { setTimeout(update, 0); });
  }
})();

(function(){
  var v=document.querySelector('[data-hero-video]');
  if(!v) return;
  v.src=window.matchMedia('(min-width:861px)').matches?v.dataset.hd:v.dataset.sd;
  var still=window.matchMedia('(prefers-reduced-motion: reduce)').matches,visible=false;
  function play(){var p=v.play();return p&&p.catch?p:Promise.resolve();}
  if(!still){
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){visible=e.isIntersecting;if(visible)play().catch(function(){});else v.pause();});},{threshold:.2}).observe(v);
    } else play().catch(function(){});
  }
  var userPause=false,soundAt=0;
  function userPauseNow(){userPause=true;v.pause();setTimeout(function(){userPause=false;},300);}
  v.addEventListener('click',function(){v.paused?play().catch(function(){}):userPauseNow();});
  v.addEventListener('pause',function(){
    if(userPause||v.muted||!visible||v.ended) return;
    if(Date.now()-soundAt<4000){v.muted=true;play().catch(function(){});}
  });
  var b=document.querySelector('[data-vid-sound]');
  function sync(){if(!b)return;var on=!v.muted;b.setAttribute('aria-pressed',String(on));b.setAttribute('aria-label',on?'Turn sound off':'Turn sound on');}
  v.addEventListener('volumechange',sync);
  if(b) b.addEventListener('click',function(e){
    e.preventDefault();e.stopPropagation();
    if(v.muted){
      userPauseNow();
      soundAt=Date.now();
      v.muted=false;
      try{v.currentTime=0;}catch(err){}
      var p=v.play();
      if(p&&p.catch) p.catch(function(){v.muted=true;play().catch(function(){});});
    } else {
      v.muted=true;
    }
  });
  var stuckAt=-1,stuckTimer=0;
  v.addEventListener('waiting',function(){
    stuckAt=v.currentTime;clearTimeout(stuckTimer);
    stuckTimer=setTimeout(function(){
      if(!visible||v.currentTime!==stuckAt) return;
      play().catch(function(){v.muted=true;play().catch(function(){});});
    },4000);
  });
  v.addEventListener('playing',function(){clearTimeout(stuckTimer);});
  var pb=document.querySelector('[data-vid-play]'),lastT=-1,lastTick=Date.now(),started=false;
  function showPlay(on){if(pb)pb.hidden=!on;}
  v.addEventListener('playing',function(){started=true;showPlay(false);});
  v.addEventListener('pause',function(){if(started)showPlay(true);});
  v.addEventListener('ended',function(){showPlay(true);});
  setInterval(function(){
    if(v.paused||!visible){lastTick=Date.now();lastT=v.currentTime;return;}
    if(v.currentTime!==lastT){lastT=v.currentTime;lastTick=Date.now();showPlay(false);}
    else if(started&&Date.now()-lastTick>1500){showPlay(true);}
  },500);
  if(pb) pb.addEventListener('click',function(e){
    e.preventDefault();e.stopPropagation();
    showPlay(false);lastTick=Date.now();
    if(!v.paused) userPauseNow();
    if(!v.muted) soundAt=Date.now();
    var p=v.play();
    if(p&&p.catch) p.catch(function(){v.muted=true;play().catch(function(){showPlay(true);});});
  });
  if(/[?&]vdebug=1/.test(location.search)){
    var d=document.createElement('pre'),evs=[];
    d.style.cssText='position:fixed;left:6px;right:6px;bottom:6px;z-index:99999;margin:0;padding:8px;background:rgba(0,0,0,.82);color:#0f0;font:11px/1.35 monospace;white-space:pre-wrap;max-height:40vh;overflow:auto';
    document.body.appendChild(d);
    ['play','playing','pause','waiting','stalled','suspend','error','volumechange','ended','emptied','abort','seeking','seeked','canplay'].forEach(function(n){v.addEventListener(n,function(){evs.push(n+'@'+v.currentTime.toFixed(2));if(evs.length>14)evs.shift();});});
    setInterval(function(){d.textContent='t='+v.currentTime.toFixed(2)+' paused='+v.paused+' muted='+v.muted+' rs='+v.readyState+' ns='+v.networkState+(v.error?' err='+v.error.code:'')+'\nsrc='+(v.currentSrc||'').split('/').pop()+'\n'+navigator.userAgent+'\n'+evs.join(' ');},250);
  }
})();

(function(){
  var v=document.querySelector('[data-hero-video]'),box=document.querySelector('[data-vid-cap]'),data=document.querySelector('[data-vid-cues]');
  if(!v||!box||!data) return;
  var cues=JSON.parse(data.textContent),out=box.firstElementChild,last=-1,raf=0;
  function tick(){
    var t=v.currentTime,idx=-1;
    for(var i=0;i<cues.length;i++){if(t>=cues[i][0]&&t<cues[i][1]){idx=i;break;}}
    if(idx!==last){out.textContent=idx<0?'':cues[idx][2];last=idx;}
    raf=v.paused?0:requestAnimationFrame(tick);
  }
  v.addEventListener('play',function(){if(!raf)raf=requestAnimationFrame(tick);});
  v.addEventListener('seeked',tick);
  var b=document.querySelector('[data-vid-cc]');
  if(b) b.addEventListener('click',function(){
    var on=b.getAttribute('aria-pressed')!=='true';
    b.setAttribute('aria-pressed',String(on));
    b.setAttribute('aria-label',on?'Hide subtitles':'Show subtitles');
    box.classList.toggle('off',!on);
  });
})();
